module.exports = __webpack_public_path__ + "static/img/29.3619cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/29.png
// module id = vGVU
// module chunks = 0